import React from "react";
import { Phone, Mail, MapPin, Youtube, Facebook, Instagram } from "lucide-react";
import logo from "../assets/image/logoFooter.png";

export default function Footer() {
  // Array para os links de navegação para facilitar a manutenção
  const navLinks = [
    { name: "Home", href: "#" },
    { name: "Nossos Produtos", href: "#" },
    { name: "Quem Somos", href: "#" },
    ({ name: "Contato", href: "#" }),
    
  ];

  // Array para os links de redes sociais
  const socialLinks = [
    { icon: <Instagram className="w-6 h-6" />, href: "https://www.instagram.com/insetobras", name: "Instagram" },
    { icon: <Facebook className="w-6 h-6" />, href: "https://www.facebook.com/inseto.bras", name: "Facebook" },
    
  ];

  return (
    <footer className="bg-green-900 text-gray-300" id="contato">
      <div className="max-w-7xl mx-auto py-12 px-4 sm:px-6 lg:px-8">
        {/* Grid principal do footer */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          
          {/* Coluna 1: Logo e Descrição */}
          <div className="space-y-4">
            <img src={logo} alt="InsetoBras Logo" className="h-32" />
            <p className="text-sm">
              Nutrição de alta qualidade para seus animais, com a confiança e sustentabilidade que só a InsetoBras oferece.
            </p>
          </div>

          {/* Coluna 2: Navegação */}
          <div className="md:mx-auto">
            <h3 className="text-lg font-semibold text-white mb-4">Navegação</h3>
            <ul className="space-y-2">
              {navLinks.map((link) => (
                <li key={link.name}>
                  <a href={link.href} className="hover:text-white transition-colors">
                    {link.name}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Coluna 3: Contato */}
          <div className="md:mx-auto">
            <h3 className="text-lg font-semibold text-white mb-4">Contato</h3>
            <ul className="space-y-3">
              <li className="flex items-center gap-3">
                <Phone className="w-5 h-5 text-orange-500" />
                <a href="tel:+5561981531285" className="hover:text-white transition-colors">(61)981531285</a>
              </li>
              <li className="flex items-center gap-3">
                <Mail className="w-5 h-5 text-orange-500" />
                <a href="mailto:contato@insetobras.com.br" className="hover:text-white transition-colors">halleydboas@gmail.com</a>
              </li>
              <li className="flex items-center gap-3">
                <MapPin className="w-5 h-5 text-orange-500" />
                <span>Brasília, DF - Brasil</span>
              </li>
            </ul>
          </div>

          {/* Coluna 4: Redes Sociais */}
          <div className="md:mx-auto">
            <h3 className="text-lg font-semibold text-white mb-4">Siga-nos</h3>
            <div className="flex items-center gap-4">
              {socialLinks.map((social) => (
                <a 
                  key={social.name}
                  href={social.href} 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="p-2 bg-green-800 rounded-full hover:bg-orange-500 hover:text-white transition-all"
                  aria-label={social.name}
                >
                  {social.icon}
                </a>
              ))}
            </div>
            <p className="mt-4 text-sm">Fique por dentro das novidades!</p>
          </div>
        </div>

        {/* Linha divisória e Direitos Autorais */}
        <div className="mt-12 pt-8 border-t border-green-800 text-center text-sm">
          <p>&copy; {new Date().getFullYear()} InsetoBras. Todos os direitos reservados.</p>
          <a href="#" className="underline hover:text-white mt-1 inline-block">Política de Privacidade</a>
        </div>
      </div>
    </footer>
  );
}
